@if ('select' === field.type) {
  <ng-container [formGroup]="form">
    <ng-container *ngTemplateOutlet="InputTemplate" [formGroupName]="field.group ? field.group : null" ></ng-container>
  </ng-container>
} @else {
  <div class="form-group mb-3">
    {{ field.control }} verkeerde input type: {{ field.type }} ipv select
  </div>
}

<ng-template #InputTemplate>
  <div class="form-group mb-3">
    <label [for]="field.control" class="text-bold">{{ field.label | translate }}</label>

    <div class="btn-group w-100" dropdown>
      @if (!selectedOptions.length) {
        <div class="form-control d-flex align-items-center dropdown-toggle" dropdownToggle>
          <span class="w-100" [innerHTML]="'form.no_option_selected' | translate: { label: (field.label | translate) } | safeHTML "></span>
        </div>
      } @else {
        <div class="form-control h-auto p-1 d-flex align-items-center dropdown-toggle" dropdownToggle>
          <div class="w-100">
            @for (option of selectedOptions; track option; let i = $index) {
              <div class="btn-group m-1">
                <button class="btn btn-xs btn-danger px-2" (click)="removeSelected(i)">x</button>
                <div class="btn btn-xs btn-primary">{{ option.label | translate }}</div>
              </div>
            }
          </div>
        </div>
      }


      <div class="dropdown-menu w-100" role="menu" *dropdownMenu>
        @for (option of options; track option) {
          <button class="dropdown-item"
            type="button"
            (click)="addSelected(option)"
            [ngClass]="{ 'text-muted disabled': isSelected(option.value)}">
            {{ option.label | translate }}
          </button>
        }
      </div>
    </div>
  </div>
</ng-template>

